export const gatewayOptions = [
  { id: 'payConex', name: 'PayConex' },
  { id: 'payConexPlus', name: 'PayConex Plus' }
];

export const toDecimal = (value: number | null) => {
  if (value === null || value === undefined) return null;
  return value > 1 ? value / 100 : value;
};

export const toPercentage = (value: number | null) => {
  if (value === null || value === undefined) return null;
  return value <= 1 ? value * 100 : value;
};
